import React from 'react'

import { Controller } from 'react-hook-form'
import { Grid, TextField } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'

import { Select } from 'components'

const NcSpecificFields = ({
  control,
  errors,
  isShow,
  ncOriginOptions,
  classificationOptions,
}) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Controller
            as={
              <Select
                label="Origem da NC *"
                fieldValue="value"
                fieldName="name"
                items={ncOriginOptions}
                error={!!errors?.ncOrigin}
                helperText={errors?.ncOrigin?.message}
              />
            }
            name="ncOrigin"
            control={control}
            defaultValue=""
            onChange={([event]) => event.target.value}
            disabled={isShow}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <Controller
            as={
              <KeyboardDatePicker
                fullWidth
                format="DD/MM/yyyy"
                label="Data da Ocorrência *"
                helperText={errors?.occurrenceDate?.message}
                error={!!errors.occurrenceDate}
                inputVariant="outlined"
                onChange={(newValue) => ({ value: newValue })}
                disabled={isShow}
              />
            }
            control={control}
            defaultValue={null}
            name="occurrenceDate"
            mode="onChange"
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <Controller
            as={
              <Select
                label="Classificação *"
                fieldValue="value"
                fieldName="name"
                items={classificationOptions}
                error={!!errors?.classification}
                helperText={errors?.classification?.message}
              />
            }
            name="classification"
            control={control}
            defaultValue=""
            onChange={([event]) => event.target.value}
            disabled={isShow}
          />
        </Grid>

        <Grid item xs={12}>
          <Controller
            as={
              <TextField
                label="Análise de Causa Raiz *"
                fullWidth
                variant="outlined"
                multiline
                minRows={4}
                error={!!errors.rootCauseAnalysis}
                helperText={errors?.rootCauseAnalysis?.message}
              />
            }
            control={control}
            name="rootCauseAnalysis"
            disabled={isShow}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default NcSpecificFields
